import { Link } from 'react-router-dom';
import { COURSE_APP_URL } from '../lib/site';
import { Logo } from './Bits';

export default function Footer() {
  return (
    <footer className="ft on-pine">
      <div className="wrap" style={{ padding: '64px clamp(20px, 4.5vw, 44px) 40px' }}>
        <div className="ft-grid">
          <div>
            <Logo dark height={42} />
            <p style={{ color: 'var(--cream-mut)', fontSize: '0.92rem', maxWidth: 260, marginTop: 14, lineHeight: 1.6 }}>
              One platform for golf courses, golfers, and suppliers. Built in Indiana.
            </p>
          </div>
          <div className="ft-col">
            <div className="ft-col-t">Platform</div>
            <Link to="/courses">LinksOS for courses</Link>
            <Link to="/golfers">The MyGolfLinks app</Link>
            <Link to="/partners">MGL Partner Portal</Link>
            <Link to="/pricing">Pricing</Link>
          </div>
          <div className="ft-col">
            <div className="ft-col-t">Company</div>
            <Link to="/why">Why MyGolfLinks</Link>
            <Link to="/founding">Founding courses</Link>
            <Link to="/about">About</Link>
            <Link to="/demo">Book a demo</Link>
          </div>
          <div className="ft-col">
            <div className="ft-col-t">Access</div>
            <a href={COURSE_APP_URL}>Course sign in</a>
            <Link to="/download">Get the app</Link>
            <Link to="/support">Support</Link>
          </div>
        </div>
        <div
          style={{
            marginTop: 52,
            paddingTop: 24,
            borderTop: '1px solid var(--cream-line)',
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            flexWrap: 'wrap',
            fontSize: '0.82rem',
            color: 'var(--cream-faint)',
          }}
        >
          <span>© 2026 MyGolfLinks, LLC. Indiana, USA.</span>
          <span style={{ display: 'flex', gap: 18 }}>
            <Link to="/privacy" style={{ color: 'var(--cream-faint)' }}>Privacy</Link>
            <Link to="/terms" style={{ color: 'var(--cream-faint)' }}>Terms</Link>
            <Link to="/support" style={{ color: 'var(--cream-faint)' }}>Support</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
